import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum'
//import { reactPlugin } from '@datadog/browser-rum-react'

if (process.env.DATADOG_APPLICATION_ID) {
  /*
  From old Sentry config:

    ignoreErrors: [
      /Non-Error promise rejection captured with value\: Object Not Found Matching Id:\d+/,
      'ResizeObserver loop limit exceeded',
      'ChunkLoadError',
      // Bots?
      /Object Not Found Matching Id.+MethodName/,
      // Tawk
      "Cannot read properties of undefined (reading '$socket')",
    ]
   */

  const init: RumInitConfiguration = {
    applicationId: process.env.DATADOG_APPLICATION_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN as string,
    site: process.env.DATADOG_SITE as RumInitConfiguration['site'],
    env: process.env.DATADOG_ENV as string,
    service: 'app',
    // TODO: version: process.env.DATADOG_VERSION as string,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    // For some reason causes no errors being posted
    // plugins: [reactPlugin({ router: true })],
  }

  datadogRum.init(init)
}
